import { getResponsiveImageProps } from '../utils/images';

// Cover image that picks the right size for the screen and loads lazily unless
// it is the first thing on the page.
function ResponsiveImage({ src, variants, alt, className, sizes = '(max-width: 820px) 100vw, 780px', priority = false }) {
    if (!src) return null;
    const responsive = getResponsiveImageProps(variants);
    return (
        <img
            className={className}
            src={src}
            alt={alt}
            sizes={responsive.srcSet ? sizes : undefined}
            {...responsive}
            loading={priority ? 'eager' : 'lazy'}
            decoding="async"
            fetchpriority={priority ? 'high' : undefined}
        />
    );
}

export default ResponsiveImage;
